<template>
  <div>
    <div class="date-wrapper">
      <FilterChipButton
          :isButtonActive="isButtonActive"
          :chipsList="chipsList"
          :clearFilter="clearFilter"
          @handleChipClick="handleChipClick"
      />
      <div v-if="filterModalIsVisible">
        <FilterModal
            :filterModalIsVisible="filterModalIsVisible"
            :currentModalFilter="currentModalFilter"
            :currentModalLabel="currentModalLabel"
            :selectedChips="selectedChips"
            :filters="filters"
            :dateError="date.error"
            :dateOption="date.option"
            :dateRange="date.selectedRange"
            @closeModal="closeModal"
            @applySelection="applySelection"
            @setItem="setItem"
        />
      </div>
    </div>
    <div v-if="isLoading">
      <v-skeleton-loader
          style="max-width: 555px"
          v-bind="attrs"
          type="card"
          v-if="isLoading"
          class="mt-2"
      >
      </v-skeleton-loader>
    </div>
    <div v-else>
      <div v-if="this.source === 'speakers'">
        <div v-for="speaker in detailsList" :key="speaker.speaker_id">
          <EventSpeakerCard :speaker="speaker"/>
        </div>
      </div>
      <div v-if="this.source === 'partners'">
        <div v-for="partner in detailsList" :key="partner.partner_id">
          <PartnerCard :partner="partner" />
        </div>
      </div>
      <div v-if="this.source === 'threads'">
        <div v-for="treads in detailsList">
          <PostPreview
              class="post-preview"
              :post="treads"
          />
        </div>
      </div>
      <div v-if="this.source === 'events'">
        <div v-for="({date, data}, i) in EventsBlock" :key="`${date}-${i}`">
          <div class="events-page__title">
            {{ date }}
          </div>
          <div v-for="eventInfo in data" :key="eventInfo.event_id">
            <EventPreview  :eventInfo="eventInfo"/>
          </div>
        </div>
      </div>
    </div>


     <div class="d-flex py-9 justify-center">
       <Pagination
           v-if="bookmarkListsMeta"
           :page="filters.page"
           :pageCount="+this.bookmarkListsMeta.pageCount"
           v-on:pageChange="onPageChange"
       />
     </div>

  </div>

</template>
<script>
import {mapActions, mapGetters} from "vuex";
import EventSpeakerCard from "@/components/Event/EventSpeakerCard.vue";
import Pagination from "@/components/Pagination.vue";
import PartnerCard from "@/components/Event/PartnerCard.vue";
import PostPreview from "@/components/Post/PostPreview.vue";
import FilterModal from "@/components/Modals/FilterModal.vue";
import FilterChipButton from "@/components/FilterChipButtons.vue";
import EventPreview from "@/components/Event/EventPreview.vue";
import Filter from "@/mixins/Filter";


export default {
  name: "BookmarkUserList",
  components: {
    EventPreview,
    FilterChipButton,
    FilterModal,
    PostPreview,
    PartnerCard,
    Pagination,
    EventSpeakerCard
  },
  mixins: [Filter],
  data(){
    return {
      source: '',
      attrs: {
        class: 'mb-6',
        elevation: 0,
      },
    }
  },
  computed:{
    ...mapGetters('profile', ['bookmarkList', 'bookmarkListsMeta', 'isLoading']),
    ...mapGetters('settings', ['appCore']),
    detailsList() {
      if(this.source === 'speakers'){
        return (this.bookmarkList || []).flatMap(item=>item.speakersList.map(speakers =>{
          if(speakers.block_name === 'speakerInfo')
            return  speakers.block_data}
        ))
      }
      if(this.source === 'events'){
        return (this.bookmarkList || []).flatMap(item=>item.eventsList.map(event =>{
          if(event.block_name === 'eventInfo')
            return  event.block_data}
        ))
      }
      if (this.source === 'partners' || this.source === 'threads'){
        return this.bookmarkList
      }
    },
    EventsBlock() {
      if(this.source !== 'events') return
      const result = []
      this.detailsList.forEach((event) => {
        const fromDate = new Date(event.event_start * 1000)
        const month = fromDate.toLocaleString('en-US', { month: 'long' })
        const year = fromDate.getFullYear()
        const key = `${month} ${year}`
        if (result.length === 0) {
          result.push({
            date: key,
            data: [event],
          })
        } else {
          const lastGroup = result[result.length - 1]
          if (lastGroup.date === key) {
            lastGroup.data.push(event)
          } else {
            result.push({
              date: key,
              data: [event],
            })
          }
        }
      })
      return result.map(({ date, data }) => ({ date, data }))
    },
    titlePage() {
      if (this.source === 'threads') {
        return 'News'
      }
      if(this.source === 'partners'){
        return 'Exhibitors'
      }
      return this.$route.query.source

    },
  },
  methods:{
    ...mapActions('profile', ['getProfileBookmarkList','clearBookmarks']),
    ...mapActions('app', ['setPageTitle']),
  },
  mounted() {
    this.setPageTitle(this.titlePage);
  },
  created(){
    this.source = this.$route.query.source.toLowerCase()

    if (!this.source) {
      return
    }
    this.getProfileBookmarkList({
      source: this.source,
      query: this.requestQuery,
    })
  },
  beforeDestroy(){
    this.clearBookmarks()
    this.setPageTitle('')
  }
}

</script>

<style lang="scss">


</style>